import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, CircularProgress, Stack } from '@mui/material';
import {
  loadHealingAsync,
  selectHealingError,
  selectHealingLoading,
} from '../../../redux/locatorDrift/locatorDriftSlice';
import HealAllPanel from './HealAllPanel';
import HealingEventsTable from './HealingEventsTable';
import HealingStats from './HealingStats';
import TopBreakersTable from './TopBreakersTable';
import { healingTabStyles } from './healingStyles';

export default function HealingTab() {
  const dispatch = useDispatch();
  const loading = useSelector(selectHealingLoading);
  const error = useSelector(selectHealingError);

  useEffect(() => {
    dispatch(loadHealingAsync());
  }, [dispatch]);

  if (loading) return <CircularProgress sx={healingTabStyles.loader} />;
  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Stack spacing={2}>
      <HealingStats />
      <HealAllPanel />
      <TopBreakersTable />
      <HealingEventsTable />
    </Stack>
  );
}
